// Readable text from a FastAPI error `detail`. A 422 sends a list of
// {loc, msg, type}; pages that showed `error.response.data.detail` in a toast
// or in JSX then rendered an object and React blanked the page (customer
// without a credit limit, decimal quantities, finance edits: "[object Object]").
// The shared i18next instance (set up by src/i18n.js); importing ../i18n
// here would initialise it again in tests that mock react-i18next.
import i18n from 'i18next';

const fieldOf = (item) => {
  const loc = Array.isArray(item?.loc) ? item.loc.filter((p) => typeof p === 'string' && p !== 'body') : [];
  return loc[loc.length - 1];
};

/** Text for a `detail` value, or null when there is nothing to show. */
export const detailText = (detail) => {
  if (detail == null || detail === '') return null;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const fields = [...new Set(detail.map(fieldOf).filter(Boolean))];
    if (fields.length) return i18n.t('shared.http.invalidFields', { fields: fields.join(', ') });
    const messages = detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
    return messages.length ? messages.join('; ') : null;
  }
  if (typeof detail === 'object') {
    return detailText(detail.message || detail.msg || detail.detail || null);
  }
  return String(detail);
};

/** Readable message from an axios error, or `fallback`. */
export const apiErrorMessage = (error, fallback) =>
  detailText(error?.response?.data?.detail) || fallback;
